import { Model } from "../mvvm/Model.js";
const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const DOMAIN_STATUS_OPTIONS = [
    { value: "", label: "Select one (optional)" },
    { value: "new_domain", label: "I need a new domain" },
    { value: "owns_domain", label: "I already own a domain" },
    { value: "subdomain_only", label: "I just want a free subdomain" },
];
export const MAX_LEAD_IMAGES = 10;
/** Lead is the structured sales payload from the marketing contact form. */
export class Lead extends Model {
    businessName;
    email;
    phone;
    domainStatus;
    projectDescription;
    imageKeys;
    constructor(businessName, email, phone, domainStatus, projectDescription, imageKeys = []) {
        super();
        this.businessName = businessName;
        this.email = email;
        this.phone = phone;
        this.domainStatus = domainStatus;
        this.projectDescription = projectDescription;
        this.imageKeys = imageKeys;
    }
    validate() {
        const errors = [];
        if (this.businessName.trim() === "")
            errors.push("Business name is required.");
        if (!EMAIL.test(this.email))
            errors.push("A valid email is required.");
        if (this.phone.trim().length < 7)
            errors.push("A valid phone number is required.");
        if (this.projectDescription.trim().length < 10) {
            errors.push("Tell us a bit more about your project (at least 10 characters).");
        }
        if (this.imageKeys.length > MAX_LEAD_IMAGES) {
            errors.push(`You can attach up to ${MAX_LEAD_IMAGES} images.`);
        }
        return errors;
    }
}
//# sourceMappingURL=Lead.js.map